import { ElectronicDocumentType } from '@repo/database/browser';
/**
 * Tipi documento FatturaPA (codici TD) che Previxio sa comporre e
 * trasmettere al Sistema di Interscambio.
 *
 * Perché una lista chiusa: il costruttore del file elettronico
 * (`document-acube-mapper.ts`) sa produrre tre strutture — la fattura
 * ordinaria (cedente = azienda, cessionario = cliente), il documento a
 * parti invertite emesso dall'azienda con un FORNITORE come cedente
 * (autofattura estera TD17-19, integrazione di reverse charge interno TD16,
 * autofattura di regolarizzazione TD20, estrazione da deposito IVA TD22 e
 * TD23, acquisto da San Marino con IVA TD28, comunicazione di omessa o
 * irregolare fatturazione TD29) e il documento emesso verso SÉ STESSI, in cui
 * cedente e cessionario sono il tenant (autoconsumo e cessioni gratuite senza
 * rivalsa TD27, autofattura per splafonamento del plafond TD21).
 *
 * Restano fuori i soli codici ABOLITI (TD10, TD11, TD12): non è una
 * limitazione del costruttore, è il tracciato che non li prevede più.
 *
 * Fatture RICEVUTE: questa lista NON le riguarda. L'import e l'archiviazione
 * delle passive accettano qualunque codice TD dell'enum.
 *
 * Quattro famiglie supportate:
 *  - vendita ordinaria: TD01, TD02, TD03, TD04, TD05, TD06, TD24, TD25, TD26
 *  - fattura semplificata (FSM10): TD07, TD08, TD09
 *  - documento a parti invertite con il fornitore come cedente: TD16
 *    (integrazione di reverse charge interno), TD17, TD18, TD19
 *    (autofatture estere), TD20 (autofattura per regolarizzazione e
 *    integrazione, emessa in COPPIA con il documento che porta l'imposta),
 *    TD22 e TD23 (estrazione di beni da un deposito IVA, senza e con
 *    versamento dell'imposta), TD28 (acquisto da San Marino con IVA su
 *    fattura cartacea), TD29 (comunicazione di omessa o irregolare
 *    fatturazione)
 *  - documento verso sé stessi: TD21 (autofattura per splafonamento del
 *    plafond dell'esportatore abituale, Ris. 16/E/2017) e TD27 (autoconsumo e
 *    cessioni gratuite senza rivalsa, art. 2 c. 2 n. 4 e 5 DPR 633/72), dove
 *    il SDI PRETENDE che cedente e cessionario coincidano (controllo 00472)
 */
export const SDI_SENDABLE_ELECTRONIC_TYPES = [
    ElectronicDocumentType.TD01,
    ElectronicDocumentType.TD02,
    ElectronicDocumentType.TD03,
    ElectronicDocumentType.TD04,
    ElectronicDocumentType.TD05,
    ElectronicDocumentType.TD06,
    ElectronicDocumentType.TD07,
    ElectronicDocumentType.TD08,
    ElectronicDocumentType.TD09,
    ElectronicDocumentType.TD16,
    ElectronicDocumentType.TD17,
    ElectronicDocumentType.TD18,
    ElectronicDocumentType.TD19,
    ElectronicDocumentType.TD20,
    ElectronicDocumentType.TD21,
    ElectronicDocumentType.TD22,
    ElectronicDocumentType.TD23,
    ElectronicDocumentType.TD24,
    ElectronicDocumentType.TD25,
    ElectronicDocumentType.TD26,
    ElectronicDocumentType.TD27,
    ElectronicDocumentType.TD28,
    ElectronicDocumentType.TD29,
];
/**
 * Classificazione dei 3 codici TD non trasmissibili.
 *
 * Il tipo `Record<Exclude<...>>` è volutamente esaustivo: se un domani l'enum
 * `ElectronicDocumentType` cresce, il nuovo codice deve entrare o tra i
 * sendable o qui, altrimenti il progetto non compila.
 */
export const SDI_UNSUPPORTED_TYPE_GROUP = {
    TD10: 'ABOLISHED',
    TD11: 'ABOLISHED',
    TD12: 'ABOLISHED',
};
/**
 * `true` se il codice TD può essere composto e trasmesso al SDI da Previxio.
 * Accetta anche `null`/`undefined` (documento senza tipo) restituendo `false`.
 */
export function isSdiSendableElectronicType(electronicType) {
    return (!!electronicType &&
        SDI_SENDABLE_ELECTRONIC_TYPES.includes(electronicType));
}
/**
 * Gruppo di esclusione di un codice TD non trasmissibile, `null` se il tipo
 * è trasmissibile (o non è un codice noto).
 */
export function getSdiUnsupportedTypeGroup(electronicType) {
    if (!electronicType || isSdiSendableElectronicType(electronicType)) {
        return null;
    }
    return (SDI_UNSUPPORTED_TYPE_GROUP[electronicType] ?? null);
}
//# sourceMappingURL=sdi-sendable-types.js.map